/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { SeoLocationFAQ } from './model/seoLocationFAQ';

/**
 * Returns fact interpolated FAQs for a given SEO location.
 */
export const apiSearchSeoCityFaqsList = (
  countryUrlPrefix: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<SeoLocationFAQ[]>({
    url: `/api/v7/seo-location/${countryUrlPrefix}/${city}--${regionSlug}--${seoSlug}/faqs/`,
    method: 'GET',
    signal,
  });
};

export const getApiSearchSeoCityFaqsListQueryKey = (
  countryUrlPrefix?: string,
  city?: string,
  regionSlug?: string,
  seoSlug?: string
) => {
  return [
    `/api/v7/seo-location/${countryUrlPrefix}/${city}--${regionSlug}--${seoSlug}/faqs/`,
  ] as const;
};

export const getApiSearchSeoCityFaqsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSearchSeoCityFaqsList>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiSearchSeoCityFaqsList>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiSearchSeoCityFaqsListQueryKey(countryUrlPrefix, city, regionSlug, seoSlug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSearchSeoCityFaqsList>>> = ({
    signal,
  }) => apiSearchSeoCityFaqsList(countryUrlPrefix, city, regionSlug, seoSlug, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(countryUrlPrefix && city && regionSlug && seoSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof apiSearchSeoCityFaqsList>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ApiSearchSeoCityFaqsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSearchSeoCityFaqsList>>
>;
export type ApiSearchSeoCityFaqsListQueryError = ErrorType<unknown>;

export function useApiSearchSeoCityFaqsList<
  TData = Awaited<ReturnType<typeof apiSearchSeoCityFaqsList>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiSearchSeoCityFaqsList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiSearchSeoCityFaqsListQueryOptions(
    countryUrlPrefix,
    city,
    regionSlug,
    seoSlug,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
